import React, { useEffect, useState } from 'react'
import closeSearchModal from '../../assets/img/close-tipo-busqueda-modal.svg'
import dropdown from '../../assets/img/modal-mobile-drowpdown-selector.svg'
import Modal from 'react-modal'
import { getFiltrosModalMobileStyles } from '../utils/styles'
import OpcionesOrdenarMobileModal from './OpcionesOrdenarMobileModal.js'

const SearchActionMobileModal = (
  {
    isOpen,
    setIsOpen,
    onRequestClose,
    distanceToToModales,
    type = 'filter',
    allPlantas = [],
    allTipos = [],
    allHoras = [],
    allEstados = [],
    plantaFilter = [],
    setPlantaFilter,
    tipoFilter = [],
    setTipoFilter,
    horaFilter = [],
    setHoraFilter,
    estadoFilter = [],
    setEstadoFilter,
    pedidos = [],
    filteredPedidos = [],
    setFilteredPedidos,
  }
) => {
  const [displayOptionsModal, setDisplayOptionsModal] = useState(false)
  const [selectedSelectorTitle, setSelectedSelectorTitle] = useState('')
  const [selectedSelectorOptions, setSelectedSelectorOptions] = useState([])
  const [selectedSelectorData, setSelectedSelectorData] = useState(null)
  const [selectedSelectorValue, setSelectedSelectorValue] = useState(null)

  const [mobileFilterValues, setMobileFilterValues] = useState({
    PLANTA: [],
    'TIPO DE PEDIDO': [],
    'VENTANA SOLICITADA': [],
    ESTADO: [],
  })

  const [mobileOrderValues, setMobileOrderValues] = useState({})

  const isOrderModal = type === 'order'

  useEffect(() => {
    if (isOpen) {
      setMobileFilterValues({
        PLANTA: plantaFilter,
        'TIPO DE PEDIDO': tipoFilter,
        'VENTANA SOLICITADA': horaFilter,
        ESTADO: estadoFilter,
      })

      setMobileOrderValues({})
    }
  }, [isOpen, type])

  const closeModal = () => {
    if (setIsOpen) {
      setIsOpen(false)
    }

    if (onRequestClose) {
      onRequestClose()
    }
  }

  const closeOptionsModal = () => {
    setDisplayOptionsModal(false)
  }

  const formatOptions = (options) => {
    return options
      .filter((option) => option && option.value !== null)
      .map((option) => ({
        label: option.label || option.value,
        value: option.value,
      }))
  }

  const filterOptions = [
    {
      label: 'PLANTA',
      filterKey: 'PLANTA',
      options: formatOptions(allPlantas),
    },
    {
      label: 'TIPO DE PEDIDO',
      filterKey: 'TIPO_PEDIDO',
      options: formatOptions(allTipos),
    },
    {
      label: 'VENTANA SOLICITADA',
      filterKey: 'HORARIO',
      options: formatOptions(allHoras),
    },
    {
      label: 'ESTADO',
      filterKey: 'ESTADO',
      options: formatOptions(allEstados),
    },
  ]

  const orderOptions = [
    {
      label: 'N° DE PEDIDO',
      orderKey: 'ID_PEDIDO',
      options: [
        {
          label: 'Mayor a menor',
          value: 'desc',
        },
        {
          label: 'Menor a mayor',
          value: 'asc',
        },
      ],
    },
    {
      label: 'VOLUMEN SOLICITADO (L)',
      orderKey: 'VOLUMEN',
      options: [
        {
          label: 'Mayor a menor',
          value: 'desc',
        },
        {
          label: 'Menor a mayor',
          value: 'asc',
        },
      ],
    },
    {
      label: 'VOLUMEN PLANIFICADO (L)',
      orderKey: 'VOLUMEN_PLANIFICADO',
      options: [
        {
          label: 'Mayor a menor',
          value: 'desc',
        },
        {
          label: 'Menor a mayor',
          value: 'asc',
        },
      ],
    },
    {
      label: 'VOLUMEN ENTREGADO (L)',
      orderKey: 'VOLUMEN_ENTREGADO',
      options: [
        {
          label: 'Mayor a menor',
          value: 'desc',
        },
        {
          label: 'Menor a mayor',
          value: 'asc',
        },
      ],
    },
  ]

  const optionsToRender = isOrderModal ? orderOptions : filterOptions

  const getSelectedLabel = (option) => {
    if (isOrderModal) {
      return mobileOrderValues[option.label]?.label || 'Seleccionar'
    }

    const selectedOptions = mobileFilterValues[option.label] || []

    if (selectedOptions.length > 0) {
      return selectedOptions[0].label || selectedOptions[0].value
    }

    return 'Seleccionar'
  }

  const openSelectorOptions = (option) => {
    const currentSelectedValue = isOrderModal
      ? mobileOrderValues[option.label]
      : mobileFilterValues[option.label]?.[0]

    setSelectedSelectorTitle(option.label)
    setSelectedSelectorOptions(option.options)
    setSelectedSelectorData(option)
    setSelectedSelectorValue(currentSelectedValue || null)
    setDisplayOptionsModal(true)
  }

  const selectSelectorOption = (selectedOption) => {
    if (!selectedSelectorData) {
      return
    }

    if (isOrderModal) {
      setMobileOrderValues({
        [selectedSelectorData.label]: selectedOption,
      })
    } else {
      setMobileFilterValues((currentValues) => ({
        ...currentValues,
        [selectedSelectorData.label]: [selectedOption],
      }))
    }

    setSelectedSelectorValue(selectedOption)
    setDisplayOptionsModal(false)
  }

  const applyMobileFilters = () => {
    if (setPlantaFilter) {
      setPlantaFilter(mobileFilterValues.PLANTA || [])
    }

    if (setTipoFilter) {
      setTipoFilter(mobileFilterValues['TIPO DE PEDIDO'] || [])
    }

    if (setHoraFilter) {
      setHoraFilter(mobileFilterValues['VENTANA SOLICITADA'] || [])
    }

    if (setEstadoFilter) {
      setEstadoFilter(mobileFilterValues.ESTADO || [])
    }

    closeModal()
  }

  const clearMobileFilters = () => {
    const emptyFilters = {
      PLANTA: [],
      'TIPO DE PEDIDO': [],
      'VENTANA SOLICITADA': [],
      ESTADO: [],
    }

    setMobileFilterValues(emptyFilters)

    if (setPlantaFilter) {
      setPlantaFilter([])
    }

    if (setTipoFilter) {
      setTipoFilter([])
    }

    if (setHoraFilter) {
      setHoraFilter([])
    }

    if (setEstadoFilter) {
      setEstadoFilter([])
    }

    closeModal()
  }

  const getSelectedOrder = () => {
    const selectedOrderLabel = Object.keys(mobileOrderValues)[0]

    if (!selectedOrderLabel) {
      return null
    }

    const selectedOrderField = orderOptions.find((option) => option.label === selectedOrderLabel)

    if (!selectedOrderField || !mobileOrderValues[selectedOrderLabel]) {
      return null
    }

    return {
      key: selectedOrderField.orderKey,
      direction: mobileOrderValues[selectedOrderLabel].value,
    }
  }

  const getComparableValue = (value) => {
    if (value === null || value === undefined) {
      return ''
    }

    const cleanedValue = value.toString().replaceAll('.', '').replaceAll(',', '.')
    const numericValue = Number(cleanedValue)

    if (!Number.isNaN(numericValue) && cleanedValue.trim() !== '') {
      return numericValue
    }

    return value.toString().toLowerCase()
  }

  const applyMobileOrder = () => {
    const selectedOrder = getSelectedOrder()

    if (!selectedOrder || !setFilteredPedidos) {
      return
    }

    const basePedidos = filteredPedidos.length > 0 ? filteredPedidos : pedidos

    const orderedPedidos = [...basePedidos].sort((a, b) => {
      const firstValue = getComparableValue(a[selectedOrder.key])
      const secondValue = getComparableValue(b[selectedOrder.key])

      if (firstValue < secondValue) {
        return selectedOrder.direction === 'asc' ? -1 : 1
      }

      if (firstValue > secondValue) {
        return selectedOrder.direction === 'asc' ? 1 : -1
      }

      return 0
    })

    setFilteredPedidos(orderedPedidos)
    closeModal()
  }

  const resetMobileOrder = () => {
    if (setFilteredPedidos) {
      setFilteredPedidos([...pedidos])
    }

    setMobileOrderValues({})
    closeModal()
  }

  const hasSelectedOrder = !!getSelectedOrder()

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        style={getFiltrosModalMobileStyles(distanceToToModales)}
      >
        <div className={`search-action-mobile-modal-main-container ${isOrderModal ? 'order-modal' : ''}`}>
          <div className="search-action-mobile-header">
            <div className="hedader-label">
              {isOrderModal ? 'Ordenar' : 'Seleccionar Filtro'}
            </div>
            <img src={closeSearchModal} alt="" onClick={closeModal} />
          </div>

          <div className="search-action-area-separator"></div>

          <div className="search-actions-blocs-container">
            {optionsToRender.map((option, index) => (
              <div className="bloc-action" key={option}>
                <div className="bloc-action-header">
                  {option.label}
                </div>
                <div className="bloc-action-selector" onClick={() => openSelectorOptions(option)}>
                  <div className="action-selector-label">
                    {getSelectedLabel(option)}
                  </div>
                  <img src={dropdown} alt="" />
                </div>
              </div>
            ))}
          </div>

          <div className="search-action-area-separator close-separator"></div>

          <div className="button-section">
            <button
              className="main-button hallow"
              onClick={isOrderModal ? resetMobileOrder : clearMobileFilters}
            >
              {isOrderModal ? 'Reestablecer Orden' : 'Borrar Filtros'}
            </button>
            <button
              className={`main-button ${isOrderModal && !hasSelectedOrder ? 'disabled' : ''}`}
              disabled={isOrderModal && !hasSelectedOrder}
              onClick={isOrderModal ? applyMobileOrder : applyMobileFilters}
            >
              {isOrderModal ? 'Ordenar' : 'Aplicar Filtros'}
            </button>
          </div>
        </div>
      </Modal>

      <OpcionesOrdenarMobileModal
        isOpen={displayOptionsModal}
        setIsOpen={setDisplayOptionsModal}
        onRequestClose={closeOptionsModal}
        distanceToToModales={100}
        title={selectedSelectorTitle}
        options={selectedSelectorOptions}
        selectedOption={selectedSelectorValue}
        onSelectOption={selectSelectorOption}
      />
    </>
  )
}

export default SearchActionMobileModal